import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';
import { SPOtherAchievementCatalogFormLocMap } from '../other-achievement-catalog-form/other-achievement-catalog-form.locs';

const pathStart = 'Other Achievements|Catalog|Add Dialog|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	portal: 'SP',
	feature: HubFeature.CandidateAccessLoginEmcOtherAchievements,
	htmlAllowed: false,
};

export type SPOtherAchievementCatalogAddLocNames =
	| 'SPOtherAchievementCatalogAddTitle'
	| 'SPOtherAchievementCatalogAddVendor'
	| 'SPOtherAchievementCatalogAddName'
	| 'SPOtherAchievementCatalogAddVendorReq'
	| 'SPOtherAchievementCatalogAddNameReq'
	| 'SPOtherAchievementCatalogAddExternalId'
	| 'SPOtherAchievementCatalogAddExternalIdHint'
	| 'SPOtherAchievementCatalogAddReimbursable'
	| 'SPOtherAchievementCatalogAddSuccess'
	| 'SPOtherAchievementCatalogAddError'
	| 'SPOtherAchievementCatalogAddSaveAction'
	| 'SPOtherAchievementCatalogAddCancelAction';

export const spOtherAchievementCatalogAddLocs: LocDefs<SPOtherAchievementCatalogAddLocNames> = {
	SPOtherAchievementCatalogAddTitle: {
		defaultValue: 'Add Other Achievement',
		description: 'Title for the dialog to add an other achievement',
		displayPath: `${pathStart}Title`,
		displayType: 'Title',
		...sharedProperties,
	},
	SPOtherAchievementCatalogAddVendor: {
		defaultValue: 'Sponsor/Vendor',
		description: 'Label for the vendor field',
		displayPath: `${pathStart}Vendor`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPOtherAchievementCatalogAddName: {
		defaultValue: 'Achievement Name',
		description: 'Label for the name field',
		displayPath: `${pathStart}Name`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPOtherAchievementCatalogAddVendorReq: {
		defaultValue: 'Sponsor/Vendor is Required',
		description: 'Error displayed when the sponsor/vendor field is empty',
		displayPath: `${pathStart}Vendor Required`,
		displayType: 'Error',
		...sharedProperties,
	},
	SPOtherAchievementCatalogAddNameReq: {
		defaultValue: 'Achievement Name is Required',
		description: 'Error displayed when the name field is empty',
		displayPath: `${pathStart}Name Required`,
		displayType: 'Error',
		...sharedProperties,
	},
	SPOtherAchievementCatalogAddExternalId: {
		defaultValue: 'Achievement Code',
		description: 'Label for the achievement code field',
		displayPath: `${pathStart}Code`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPOtherAchievementCatalogAddExternalIdHint: {
		defaultValue: 'If left blank, the system will generate code',
		description: 'Message displayed indicating that a blank code will be auto-generated.',
		displayPath: `${pathStart}Auto-Generated Code Hint`,
		displayType: 'Content',
		...sharedProperties,
	},
	SPOtherAchievementCatalogAddReimbursable: {
		defaultValue: 'Reimbursable',
		description: 'Label for the reimbursable checkbox',
		displayPath: `${pathStart}Reimbursable`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPOtherAchievementCatalogAddSuccess: {
		defaultValue: 'Other achievement created successfully',
		description: 'Notification message for a successful save',
		displayPath: `${pathStart}Success`,
		displayType: 'Notification',
		...sharedProperties,
	},
	SPOtherAchievementCatalogAddError: {
		defaultValue: 'There was a problem creating the other achievement',
		description: 'Notification message for an error saving',
		displayPath: `${pathStart}Error`,
		displayType: 'Notification',
		...sharedProperties,
	},
	SPOtherAchievementCatalogAddSaveAction: {
		defaultValue: 'Add Other Achievement',
		description: 'Text for the save button',
		displayPath: `${pathStart}Save`,
		displayType: 'Button',
		...sharedProperties,
	},
	SPOtherAchievementCatalogAddCancelAction: {
		defaultValue: 'Cancel',
		description: 'Text for the cancel button',
		displayPath: `${pathStart}Cancel`,
		displayType: 'Button',
		...sharedProperties,
	},
};

export type SPOtherAchievementCatalogAddLocType = LocMap<SPOtherAchievementCatalogAddLocNames>;

export const addFormLocs: SPOtherAchievementCatalogFormLocMap<SPOtherAchievementCatalogAddLocType> = {
	VendorLabel: 'SPOtherAchievementCatalogAddVendor',
	NameLabel: 'SPOtherAchievementCatalogAddName',
	VendorRequired: 'SPOtherAchievementCatalogAddVendorReq',
	NameRequired: 'SPOtherAchievementCatalogAddNameReq',
	ExternalIdLabel: 'SPOtherAchievementCatalogAddExternalId',
	ExternalIdHint: 'SPOtherAchievementCatalogAddExternalIdHint',
	ReimbursableLabel: 'SPOtherAchievementCatalogAddReimbursable',
	SaveButton: 'SPOtherAchievementCatalogAddSaveAction',
	CancelButton: 'SPOtherAchievementCatalogAddCancelAction',
};
